// SLIKZ theme - hero spotlight
document.querySelectorAll('[data-wall]').forEach(function (wall) {
  var lit = wall.querySelector('[data-lit]');
  if (!lit) return;
  wall.addEventListener('pointermove', function (e) {
    var r = wall.getBoundingClientRect();
    lit.style.setProperty('--mx', (e.clientX - r.left) + 'px');
    lit.style.setProperty('--my', (e.clientY - r.top) + 'px');
  });
});

// Mobile navigation
(function () {
  var burger = document.getElementById('navBurger');
  var links = document.getElementById('navLinks');
  if (!burger || !links) return;
  burger.addEventListener('click', function () {
    var on = links.classList.toggle('on');
    burger.classList.toggle('on', on);
    burger.setAttribute('aria-expanded', on);
  });
  links.addEventListener('click', function (e) {
    if (e.target.tagName === 'A') {
      links.classList.remove('on');
      burger.classList.remove('on');
      burger.setAttribute('aria-expanded', 'false');
    }
  });
})();
